import useGenerateTerm from '@/core/domain/reports/terms/GenerateTerm.hook';
import { DirectSale } from '@/core/domain/sales/DirectSale/DirectSale.types';
import useFileLoading, { FILE_FORMAT, FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { Button, Popover, Space } from 'antd';

interface Props {
  directSale?: DirectSale;
}
export default function DirectSaleTermGenerateButton({ directSale }: Props) {
  const report = useReportGenerate();
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();
  const generateTerm = useGenerateTerm('Termo LGPD');

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      if (directSale) {
        const obj = {
          companyId: directSale.companyId,
          customerId: directSale.customerId,
          format: FILE_FORMAT[format],
        };
        const result = await generateTerm.mutateAsync(obj);

        if (callback) {
          callback(result);
        }
      }
    } finally {
      setFileUnloading(format);
    }
  };

  return (
    <Popover
      title="Gerar"
      trigger="click"
      content={
        <Space direction="vertical">
          <Button
            block
            size="small"
            onClick={() => {
              handleGenerateReport('PDF', (result) =>
                report.downloadFile({
                  result,
                  fileName: 'termo_lgpd.pdf',
                }),
              );
            }}
            loading={fileLoading.PDF}
          >
            PDF
          </Button>

          <Button
            block
            size="small"
            onClick={() =>
              handleGenerateReport('REPORT_VIEW', (result) =>
                report.openFile({
                  result,
                  fileName: 'termo_lgpd.pdf',
                  fileType: 'application/pdf',
                }),
              )
            }
            key="viewReport"
            loading={fileLoading.REPORT_VIEW}
          >
            Visualizar
          </Button>
        </Space>
      }
    >
      <Button type="primary" block>
        Termo LGPD
      </Button>
    </Popover>
  );
}
